// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__fJpo-","topBottomGutter":"Layout_topBottomGutter__34DI5"};